<template>
    <div class="data-title xy-center">
        <img :src="require('@/assets/img/admin/result-paper-title.svg')" alt="">
        <slot></slot>
        <img :src="require('@/assets/img/admin/result-paper-title.svg')" alt="">
    </div>
</template>

<script>
export default {
    name: "ResultPaperTitle"
}
</script>

<style scoped lang="less">
    .data-title {
        font-size: 18px;
        font-weight: 500;
        height: 70px;
        background: #F4F5F6;
        margin: 50px 30px 30px;
        img {
            margin: 0 18px;
            height: 20px;
        }
    }
</style>
